import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Modalidade } from '../models/modalidade';

@Injectable({
  providedIn: 'root'
})
export class ModalidadeService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc, status, idTransp?) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '')
      .set('status', status ? status.toString() : '')
      .set('idTransp', idTransp ? idTransp.toString() : '');

    return this.http.get<any>(globals.apiUrl + '/api/Modalidade/ListaPag',
      {
        params: parametros
      });
  }

  listarModalidades(status, semTransp, idTransp?) {
    let parametros = new HttpParams()
      .set('status', status)
      .set('semTransp', semTransp.toString());

    if (idTransp != null && idTransp != undefined) {
      parametros = parametros.set('idTransp', idTransp.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Modalidade/Lista',
      {
        params: parametros
      });
  }

  listarModalidadesExistentes(idTransp?) {
    let parametros = new HttpParams();

    if (idTransp != null && idTransp != undefined) {
      parametros = parametros.set('idTransp', idTransp.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Modalidade/ModalidadesExistentes',
      {
        params: parametros
      });
  }

  listarGrupos() {
    return this.http.get<any>(globals.apiUrl + '/api/Modalidade/ListarGrupos');
  }

  buscarModalidade(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Modalidade/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(modalidade: Modalidade) {
    return this.http.post(globals.apiUrl + '/api/Modalidade/Salvar', modalidade,
      { responseType: 'text' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Modalidade/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
